import { useAppSelector } from 'store/Store';
import { Container } from 'reactstrap';

import GuestHeader from 'layouts/header/GuestHeader';
import PropTypes from 'prop-types';

const GuestLayout = ({ children }) => {
  GuestLayout.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  };

  const customizerToggle = useAppSelector((state) => state.customizer.customizerSidebar);
  const showMobileSidebar = useAppSelector((state) => state.customizer.isMobileSidebar);
  const topbarFixed = useAppSelector((state) => state.customizer.isTopbarFixed);
  const LayoutHorizontal = useAppSelector((state) => state.customizer.isLayoutHorizontal);
  const isFixedSidebar = useAppSelector((state) => state.customizer.isSidebarFixed);

  return (
    <main>
      <div className="pageWrapper d-md-block d-lg-flex">
        <div className={`contentArea ${topbarFixed ? 'fixedTopbar' : ''}`}>
          {/********header**********/}
          <GuestHeader />
          {/********Middle Content**********/}
          <Container fluid className="p-4 boxContainer">
            <div className={isFixedSidebar && LayoutHorizontal ? 'HsidebarFixed' : ''}>
              {children}
            </div>
            {/* <Customizer className={customizerToggle ? 'showCustomizer' : ''} /> */}
            {showMobileSidebar || customizerToggle ? <div className="sidebarOverlay" /> : ''}
          </Container>
        </div>
      </div>
    </main>
  );
};

export default GuestLayout;
